import { render } from "./TheDynamicInputAnamnesis.vue?vue&type=template&id=082fa52c&ts=true"
import script from "./TheDynamicInputAnamnesis.vue?vue&type=script&lang=ts"
export * from "./TheDynamicInputAnamnesis.vue?vue&type=script&lang=ts"

import "./TheDynamicInputAnamnesis.vue?vue&type=style&index=0&id=082fa52c&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__